import { BorerShiftDocument } from '../BorerShift/queryBuilder';
import { BorerShiftCommentTypeDocument } from '../BorerShiftCommentType/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  BorerShiftCommentDocument,
  borerShiftCommentPullQueryBuilder,
  borerShiftCommentPushQueryBuilder,
} from './queryBuilder';

export function borerShiftCommentFamilyMember(
  configBuilder: ConfigBuilder,
  borerShift: FamilyMember<BorerShiftDocument>,
  borerShiftCommentType: FamilyMember<BorerShiftCommentTypeDocument>,
): FamilyMember<BorerShiftCommentDocument> {
  const syncConfig = configBuilder<BorerShiftCommentDocument>(
    RxdbCollectionNameV2.BORER_SHIFT_COMMENT,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, borerShiftCommentPullQueryBuilder);
  push(syncConfig, borerShiftCommentPushQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.BORER_SHIFT_COMMENT, replicationState, [
    borerShift,
    borerShiftCommentType,
  ]);
}
